import json from './i18n.es.json'

export default {
  ...json,
}
